<template>
  <footer class="app-footer">
    <span class="d-sm-down-none"></span>
    <span class="float-right">
      <a href="javascript:void(0);"><strong>ZSistema</strong></a> | {{$lang.Login.LabelVersion}} {{version}}
    </span>
  </footer>
</template>
<script>
export default {
  name: 'AppFooter',
  data () {
    return {
      version: process.env.VersionApp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/layout/Footer.vue